import React from 'react';
import headerActions from '../../../../actions/header';
import translate from '../../../../utils/translate';

export default class MajorCategoryMore extends React.Component {
  static propTypes = {
    isActive: React.PropTypes.bool,
    panel:    React.PropTypes.string
  };

  toggleCategory = () => {
    headerActions.toggleCategory('more', this.props.panel);
  };

  render () {
    var linkClass = this.props.isActive
                  ? 'majorcategories__link--more is-active'
                  : 'majorcategories__link--more';

    return (
      <li className="majorcategories__item">
        <button
          className={linkClass}
          onClick={this.toggleCategory}
          data-component="majorCategoryItem">
          <span className="majorcategories__link__txt">
            {translate('categoryNavigationModule', 'MORE')}
          </span>
        </button>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/majorcategories/more/index.js